import {REPORTS} from '../../actions/reports/reportsActionsTypes';

const INITIAL_STATE = {
  reportsVideo: [],
  reportsPhoto: [],
  reportsVideoLoading: true,
  reportsPhotoLoading: true,
  time: new Date().getTime()
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case REPORTS.REPORTS_UPDATE_TIME:
      return {
        ...state,
        time: new Date().getTime()
      };
    case REPORTS.GET_PHOTO_REPORTS:
      return {
        ...state
        // reportsPhotoLoading: true
      };
    case REPORTS.GET_PHOTO_REPORTS_SUCCESS:
      return {
        ...state,
        reportsPhoto: action.payload.data.data,
        reportsPhotoLoading: false
      };
    case REPORTS.GET_PHOTO_REPORTS_FAIL:
      return {
        ...state,
        reportsPhoto: [],
        reportsPhotoLoading: false
      };

    case REPORTS.GET_VIDEO_REPORTS:
      return {
        ...state
        // reportsVideo: []
        // reportsVideoLoading: true
      };
    case REPORTS.GET_VIDEO_REPORTS_SUCCESS:
      return {
        ...state,
        reportsVideo: action.payload.data.data,
        reportsVideoLoading: false
      };
    case REPORTS.GET_VIDEO_REPORTS_FAIL:
      return {
        ...state,
        reportsVideo: [],
        reportsVideoLoading: false
      };
    case REPORTS.CLEAR_REPORTS:
      return {
        reportsVideo: [],
        reportsPhoto: [],
        reportsVideoLoading: true,
        reportsPhotoLoading: true
      };
    default:
      return state;
  }
}
